import { Component } from '@angular/core';

@Component({
  selector: 'app-tennis-content',
  templateUrl: './tennis-content.component.html',
  styleUrls: ['./tennis-content.component.css']
})
export class TennisContentComponent {

}
